import React, { useState } from 'react';
import { Box } from '../../../box/box';
import { Cell } from '../../../cell/cell';
import { Container } from '../../../container/container';
import { FormControl } from '../../../form-control/form-control';
import { FormDialog } from '../../../form-dialog/form-dialog';
import { Row } from '../../../row/row';
import { TeamLookup } from '../../../lookups/team-lookup/team-lookup';
import { UserLookup } from '../../../lookups/user-lookup/user-lookup';

export interface IAssignCaseworkerDialogComponentProps {
  teamId?: string;
  userId?: string;
  isLoading?: boolean;
  onTeamChange: (team: string | undefined) => void;
  onUserChange: (userId: string | undefined) => void;
  isOpen: boolean;
  onConfirm: () => void;
  onClose?: () => void;
}

export function AssignCaseworkerDialogComponent({ teamId, userId, onTeamChange, onUserChange, isOpen, onConfirm, onClose, isLoading }: IAssignCaseworkerDialogComponentProps) {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleConfirm = () => {
    setIsSubmitted(true);
    onConfirm();
  };

  return (
    <FormDialog
      open={isOpen}
      title="Tildel ansvarlig sagsbehandler"
      confirmButtonText="Udfør"
      cancelButtonText="Afbryd"
      isLoading={isSubmitted || isLoading}
      onConfirmClick={handleConfirm}
      onClose={onClose}
      onCancelClick={onClose}
      maxWidth="lg"
      isValid
    >
      <FormControl fullWidth>
        <Container>
          <Box width="1000px">
            <Row>
              <Cell size="full">
                <UserLookup value={userId} onChange={onUserChange} />
              </Cell>
              <Cell size="full">
                <TeamLookup required value={teamId} onChange={onTeamChange} disableClearable />
              </Cell>
            </Row>
          </Box>
        </Container>
      </FormControl>
    </FormDialog>
  );
}
